import React from "react";
import Modal from 'react-awesome-modal';
import { observer } from "mobx-react";
import store from '../Stores/SurveyStore'

const LogoutConfirmModal = observer(() => {
    const closeLogoutModal = () => {
        store.showLogoutModal = false;
    }

        return (
            <React.Fragment>
                <section>
                    <Modal
                        visible={store.showLogoutModal}
                        width="600"
                        height="200"
                        effect="fadeInDown"
                        onClickAway={closeLogoutModal}
                    >
                        <div className="helpModal">
                            <h3> <i className="fa fa-sign-out-alt"></i> Are you sure you want to logout?
                                <span onClick={closeLogoutModal} className="close-button topright">&times;</span>
                                </h3>

                            <hr />
                            <div className="center-div">
                                <a onClick={closeLogoutModal} className="btn btn-info2 grey" role="button">Stay on survey</a>
                                <a href="/logout" className="btn btn-info2" role="button">Log out</a><br />
                            </div>
                            
                        </div>
                    </Modal>
                </section>
            
            </React.Fragment>
        );
  
});

export default LogoutConfirmModal;